<template>
  <div class="tvprogram tvprogram-select">
    <ul class="tvprogram-select-wrapper tablet desktop">
      <li v-for="(labelItem, index) in store.labels" :title="labelItem.label" class="tvprogram-select-item"
          :class="index === store.current ? 'selected' : ''">
        <a v-on:click="changeCurrent(index)">
          <span>{{ labelItem.label }}</span>
        </a>
      </li>
    </ul>

    <select class="tvprogram-select-wrapper phone"
            @change="changeCurrentMobile($event)"
    >
      <option v-for="(labelItem, index) in store.labels"
              :title="labelItem.label"
              class="tvprogram-select-item"
              :value="index"
              :selected="index === store.current ? 'selected' : ''">
        {{ labelItem.label }}
      </option>
    </select>

  </div>
</template>

<script>

import axios from 'redaxios/dist/redaxios';
import {store} from "./TvProgramStore";

export default {
  name: 'TvProgramSelect',
  data: () => {
    return {
      store
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    this.fetchLabels();
  },
  methods: {
    changeCurrent: function (index) {
      if (index === store.current) {
        return false;
      }
      this.emitter.emit('reset-dropdowns', 'reset');
      store.setIsLoading(true)
          .setCurrent(index);
      this.fetchTvProgram();
      return false;
    },
    changeCurrentMobile(evt) {
      this.changeCurrent(evt.target.value);
    },
    getCurrentSelection: function () {
      store.labels.forEach((element, index) => {
        if (element.selected) {
          store.setCurrent(index);
          this.fetchTvProgram();
        }
      })
    },
    async fetchLabels() {
      let self = this;
      await axios.get('/ajax?get=tvprogram&getDayLabels=1')
          .then(response => {
            store.setIsLoading(true);
            if (response.status === 200) {
              store.setLabels(response.data.data);
              self.getCurrentSelection();
            }
          })
          .catch(error => {
            console.log('🌞', error);
          });
    },
    async fetchTvProgram() {
      let uri = `/ajax?get=tvprogram&dayIndex=${store.current}`;
      await axios.get(uri)
          .then(response => {
            if (response.status === 200) {
              store.resetData()
                  .setData(response.data.data)
                  .setIsLoading(false);
            }
          })
          .catch(error => {
            console.log('🌞', error);
          });
    }
  }
}
</script>

<style lang="scss">
</style>